import { GLTFLoader as BaseLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'

export class GLTFLoader {
  constructor (loadingManager) {
    this.loader = new BaseLoader(loadingManager)
    const dracoLoader = new DRACOLoader()
    dracoLoader.setDecoderPath('/draco/')
    this.loader.setDRACOLoader(dracoLoader)
  }

  load (url, objectsOnly = false, setupItem = ()=>{}) {
    return new Promise((resolve, reject) => {
      const toRemove = []

      this.loader.load(url, object => {
        object.scene.traverse( (child) => {
          if (child.isMesh) {
            setupItem(child)
          }
          else {
            if (objectsOnly && child.children.length === 0) {
              toRemove.push(child)
            }
          }
        })

        if (objectsOnly) {
          toRemove.forEach(obj => object.scene.remove(obj))
        }

        resolve(object)

      }, null, reject)
    })
  }
}